import { Link } from "react-router-dom";

export interface Crumb {
  label: string;
  path?: string;
}

interface BreadcrumbProps {
  items: Crumb[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  return (
    <nav aria-label="面包屑导航" className="flex flex-wrap items-center gap-1.5 text-xs text-foreground-500">
      <Link to="/" className="transition-colors hover:text-primary-700">
        首页
      </Link>
      {items.map((item) => (
        <span key={item.label} className="flex items-center gap-1.5">
          <i className="ri-arrow-right-s-line text-foreground-300"></i>
          {item.path ? (
            <Link to={item.path} className="transition-colors hover:text-primary-700">
              {item.label}
            </Link>
          ) : (
            <span className="text-foreground-800">{item.label}</span>
          )}
        </span>
      ))}
    </nav>
  );
}